<div class="loader" *ngIf="this.isBusy">
    <div class="centered-content">
        <div class="messageHeader">{{headerText}}</div>
        <div class="messageBody">
            <mat-spinner diameter="25" class="centered_spinner"> </mat-spinner> {{busyText}}
        </div>
    </div>
</div>
